<template>
    <div>
        <canvas v-for="item in totalPage" :key="item" :id='"the-canvas" + item' class="pdf-content"></canvas>
    </div>
</template>
<script>
import PDFJS from 'pdfjs-dist'
export default {
    data(){
        return {
            url:"//cdn.edstatic.com/203012120000/4251c0d0eda11633ad03774e080901fb/2021/10/f73ee38d-97f3-422e-9525-282e801d84f4.pdf",
            numPages: 1, // pdf 总页数
            id:this.$route.query.id
      }
    },
    created(){
        let winW = document.documentElement.clientWidth;
        let loadingTask = PDFJS.getDocument({url:this.url});
        loadingTask.promise.then(function (pdf) {
            let pageNum = pdf.numPages
                for (let i = 1; i <= pageNum; i++) {
                     pdf.getPage(i).then(function (page) {
                        let viewport = page.getViewport(1)
                        let scale = (winW / viewport.width).toFixed(2)
                        let scaledViewport = page.getViewport(scale)
                        let canvas = document.getElementById('the-canvas' + i)
                        let context = canvas.getContext('2d')
                        canvas.height = scaledViewport.height
                        canvas.width = scaledViewport.width
                        let renderContext = {
                            canvasContext: context,
                            viewport: scaledViewport
                        }
                        let renderTask = page.render(renderContext)
                        renderTask.then(function () {
                        })
                    })
                }
                }, function (reason) {
                     console.error(reason)
        })

    },
    mounted() {
        // this.getNumPages()
    },
    methods: {
        getUrl(){
            const url=MeetingsCarousel;
			let params={
				id:this.id
			}
			const method='POST';
			fetch(url,params,method).then((res)=>{
				if(res.code==0){
                    
                    this.getNumPages();
						
				}
			})
        },
        // 计算pdf页码总数
        // getNumPages() {
        //     // # 计算pdf页码总数
        //     let loadingTask = pdf.createLoadingTask(this.url);
        //     console.log(loadingTask);
        //     loadingTask.promise.then(pdf => {
        //         // this.url=loadingTask;
        //         this.numPages = pdf.numPages;
        //     }).catch(err => {
        //         console.error('pdf 加载失败', err);
        //     })
        // },
    //     pdfPreview(url){
    //         this.$http({
    //             url: 'account/registerOpen/${url}',
    //             method: 'get',
    //             responseType: 'arraybuffer',   //一定要设置响应类型，否则页面会是空白pdf
    //             params: { accountId: id, lang: 'en_US' }
    //         }).then(res => {
    //             const binaryData = [];
    //             binaryData.push(res);
    //             //获取blob链接
    //             this.pdfUrl = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/pdf' }));
    //             window.open(this.pdfUrl);
    //         })
    //     },
    //     docLoaded(){
    //         console.log('加载中')
    //     },
    //     pageLoaded(){
    //         console.log('加载结束')
    //     }

    }
    
}
</script>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/ShowPdf.vue